import type { DocumentType } from '@/features/documents/DocumentType'
import { type JobsApi } from '@/features/jobs/api/job-api'
import { SubmitDocumentRequestInput } from '@taxfyle/api-internal/internal/document_request_pb'
import { Id } from '@/infra/id'

export interface SubmitDocumentRequestOptions {
  jobId: Id
  documentTypes: DocumentType[]
}

export class DocumentRequestStore {
  constructor(private readonly _api: JobsApi) {}

  /**
   * Submits a document request for a job.
   */
  async submitDocumentRequest({
    jobId,
    documentTypes,
  }: SubmitDocumentRequestOptions) {
    const ids = documentTypes
      .map((t) => t.id?.toString())
      .filter((id) => id !== undefined)

    const request = new SubmitDocumentRequestInput()
    await this._api.documentRequests.submitDocumentRequest(
      request.setRequestedIdsList(ids).setJobId(Id.assert(jobId)),
    )
  }
}
